__turbopack_context__.v({
  "contract": "PdpStatusBadge-module__653RhW__contract",
  "neutral": "PdpStatusBadge-module__653RhW__neutral",
  "new": "PdpStatusBadge-module__653RhW__new",
});
